import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class ApigeeService {
  constructor(
    private readonly http: HttpClient,
    private readonly notificationService: NotificationService,
    private readonly appConfigService: AppConfigService,
  ) {}

  getQrPDF(pais: any, verificationCode: any, token: string): Observable<any> {
    let body = {
      verificationCode: verificationCode,
      recaptchaToken: token,
    };

    return this.http
      .post<any>(
        `${this.appConfigService.config.apigeeDomain}/v1/countries/${pais}/reports/qr/validator`,
        body,
        { withCredentials: false },
      )
      .pipe(catchError((error) => this.handleError(error)));
  }

  handleError(errorResp: HttpErrorResponse) {
    let tempErr = errorResp.error?.additionalErrorDetails[0]?.message;
    this.notificationService.openLargeMessage({
      severity: 'error',
      message: tempErr ? tempErr : 'Error desconocido.',
      title: 'Error',
    });
    return throwError(() => errorResp);
  }
}
